<template>
  <vs-wrapper space="small">
    <vs-heading data-test="job-form-title" type="overline">{{ name }}</vs-heading>
    <v-skeleton-loader v-if="isLoading" type="image" rounded />
    <div v-else-if="error">
      <vs-alert type="error">Failed to load {{ name }} form submission</vs-alert>
    </div>
    <submission-field
      v-else
      :flattened-fields="flattenedFormFields"
      :submission-data="props.customData"
    />
  </vs-wrapper>
</template>

<script setup lang="ts">
import VsHeading from '@/components/vision/VsHeading.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import { computed, toRef } from 'vue'
import { useSyncTargetCustomSchema } from '@/api/schemas'
import { extractFieldsFromSchema } from '@/utils/field-schema-helper'
import type { CustomField } from '@/models/types/custom-field'
import VsAlert from '@/components/vision/VsAlert.vue'

const props = defineProps<{
  name: string
  appId: string
  schemaVersionId: number
  customData: Record<string, any> | null
}>()

const appIdRef = toRef(props, 'appId')
const schemaVersionIdRef = toRef(props, 'schemaVersionId')

const {
  data: schemaData,
  isLoading,
  error,
} = useSyncTargetCustomSchema({
  appId: appIdRef,
  schemaId: schemaVersionIdRef,
})

const flattenedFormFields = computed<Record<string, CustomField>>(() => {
  if (props.customData === null || schemaData.value === undefined) {
    return {}
  }

  const { schema, uiSchema } = schemaData.value.json_schema
  const formFields: Record<string, CustomField> = {}
  extractFieldsFromSchema(schema, uiSchema, formFields)
  return formFields
})
</script>
